import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from "UI/Skeleton";
import Card, {CardFooter, CardHeader} from "UI/Card";

export default class ProjectCardSkeleton extends React.Component
{
    render()
    {
        const title = <div className='flex items-center'>
            <Skeleton className='w-4 h-4 mr-2 rounded' />
            <Skeleton className='h-7 w-24 rounded' />
        </div>;

        const header = <CardHeader title={title} />;

        const footer = <CardFooter className='flex flex-row-reverse space-x-2'>
            <Skeleton className='mr-1 h-4 w-6 rounded' />
        </CardFooter>;

        return <Card header={header} footer={footer}>
            <Skeleton className='h-4 w-16 rounded' />
        </Card>;
    }
}